import { PageRefValue } from '@fullstory/search-types';

export enum ValueType {
  Url,
  Page,
  Screen,
}

export interface UrlValue {
  type: ValueType.Url;
  value: string;
}

export interface PageDefValue {
  type: ValueType.Page;
  value: PageRefValue | null;
}

export interface ScreenValue {
  type: ValueType.Screen;
  value: string;
}

export type PrimaryValue = UrlValue | PageDefValue | ScreenValue;
